import React from "react";
import {
  Dialog,
  DialogContent,
  Typography,
  Grid,
  DialogActions,
  Button,
  ButtonGroup,
} from "@material-ui/core";
import { Check, Close } from "@material-ui/icons";

import { useSelector, useDispatch } from "react-redux";
import menuActions from "../../../../../../redux/actions/menu.actions";

export default function ConfirmDelete() {
  const menu = useSelector((state) => state.menu);
  const dispatch = useDispatch();

  const handleCancel = () => {
    dispatch(menuActions.setMenusDeleteModal(false));
  };

  const handleDelete = () => {
    dispatch(menuActions.setMenusDeleteModal(false));
    dispatch(menuActions.setMenusView("VIEW"));
    //funcion de eliminacion
  };
  return (
    <Dialog open={menu.menus.deleteModal}>
      <DialogContent>
        <Grid container>
          <Grid item xs={12}>
            <Typography variant="h6">Eliminar menú</Typography>
            <hr />
          </Grid>
          <Grid item xs={12}>
            <Typography variant="body1">
              ¿Estás seguro de que deseas eliminar este menú?
            </Typography>
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <ButtonGroup size="small" color="primary">
          <Button
            variant="outlined"
            onClick={() => handleCancel()}
            startIcon={<Close />}
          >
            No, salir
          </Button>
          <Button
            variant="contained"
            onClick={() => handleDelete()}
            startIcon={<Check />}
          >
            Sí, eliminar
          </Button>
        </ButtonGroup>
      </DialogActions>
    </Dialog>
  );
}
